// 受保护路由守卫（四门户镜像契约 · 唯一路径 src/auth/RequireAuth.tsx）
// 核心已下沉 web/shared/components/RequireAuth（FE2-018 注入式）：本端注入
// @/api/client 会话判定与 {lang} 前缀登录路径（与下沉前
// localePath('/login', isChdLang(lang) ? lang : getPreferredLang()) 逐字节等价；
// loginPath 仅在无会话时被调用，解析时机与原实现一致）。
import { useParams } from 'react-router-dom';
import SharedRequireAuth from '@shared/components/RequireAuth';
import { loadSession } from '@/api/client';
import { getPreferredLang, isChdLang, localePath } from '@/i18n/localePath';

export default function RequireAuth() {
  const { lang } = useParams<{ lang: string }>();
  return (
    <SharedRequireAuth
      isAuthenticated={() => Boolean(loadSession()?.accessToken)}
      loginPath={() => localePath('/login', isChdLang(lang) ? lang : getPreferredLang())}
    />
  );
}
